import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../../http_client";

import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { ApiStateWidgetActionTypes } from "./types";

export function* handleFetch(action: ReturnType<typeof fetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/widgets/api_state/", action.payload, source.token);
    yield put(fetchSuccess(res.data));
  } catch (err) {
    yield put(fetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchApiStatesWidgetSagas(): SagaIterator {
  yield takeLatest(ApiStateWidgetActionTypes.FETCH_REQUEST, handleFetch);
}

export default watchApiStatesWidgetSagas;
